import React, { Component } from "react";
import { connect } from "react-redux";
import Popup from "./Popup";
import Message from "./Message";
class FullScreenElements extends Component {
  render() {
    const { site } = this.props;
    return (
      <React.Fragment>
        {site.popup.show && <Popup />}
        {site.message.show && <Message />}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, {})(FullScreenElements);
